angular.module('ihestiaCrossTab', [])
  .run(['ihestiaCrossTabHelper', function run (ihestiaCrossTabHelper) {
    }]);
